module.exports = __webpack_public_path__ + "static/img/player_01_ph.7b1f403.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_01_ph.png
// module id = QDXo
// module chunks = 0